import React, { useState } from 'react';
import { useAdmin } from '../contexts/AdminContext';
import { Input } from './ui/input';

const EditableText = ({ value, field, onUpdate, className = '', type = 'text', prefix = '', suffix = '' }) => {
  const { isAdmin } = useAdmin();
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);

  const handleSave = async () => {
    if (editValue !== value) {
      await onUpdate(field, type === 'number' ? parseFloat(editValue) : editValue);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setEditValue(value);
      setIsEditing(false);
    }
  };

  // Format number with commas for display
  const formatValue = (val) => {
    if (type === 'number' && !isNaN(val)) {
      return parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
    return val;
  };

  if (isAdmin && isEditing) {
    return (
      <Input
        data-testid={`editable-input-${field}`}
        type={type}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className={`${className} h-auto p-1`}
        autoFocus
      />
    );
  }

  return (
    <span
      data-testid={`editable-text-${field}`}
      className={`${
        isAdmin
          ? 'border-b-2 border-dashed border-slate-300 hover:border-slate-900 cursor-text px-1 -mx-1 rounded hover:bg-slate-50 transition-colors'
          : ''
      } ${className} financial-number`}
      onClick={() => isAdmin && setIsEditing(true)}
    >
      {prefix}{formatValue(value)}{suffix}
    </span>
  );
};

export default EditableText;